import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';

const Single = () => {
    const [products, setProducts] = useState(null)
    var { id } = useParams();
    useEffect(() => {
        axios.get(`https://dummyjson.com/product/${id}`)
            .then(function (response) {
                // handle success
                console.log(response.data);
                setProducts(response.data)
            })
            .catch(function (error) {
                // handle error
                console.log(error);
            })
            .finally(function () {
                // always executed
            });
    }, [id])
    return (
        <>
            {/* <h1>Product Details</h1> */}
            <Container>
                <Row>
                    {
                        products == null ? 'loading.....!' : (
                            <>
                                <Col lg={4}>
                                    <img src={products.thumbnail} alt="" className='image' />
                                    {/* <img src={products.images} alt="" className='image'/> */}
                                </Col>
                                <Col>

                                    <h2 className='my-4 text-danger'>{products.title}</h2>
                                    <p className='fst-italic text-dark-emphasis'>{products.description}</p>
                                    <span >Category-  {products.category}</span><br />
                                    <span className='fw-bold'>price-  {products.price}</span><br />
                                    <span >rating-  {products.rating}</span><br />
                                    <span >stock-  {products.stock}</span><br />
                                    <span >tags-  {products.tags}</span> <br />
                                    <span >brand-  {products.brand}</span><br />
                                    <span >sku-  {products.sku}</span><br />
                                    <span >weight-  {products.weight}</span><br />
                                    <span >dimensions width-  {products.dimensions.width}</span><br />
                                    <span >warranty-  {products.warrantyInformation}</span><br />
                                    <span >shipping-  {products.shippingInformation}</span><br />
                                    <span >availability-  {products.availabilityStatus}</span><br />
                                    <span >return Policy-  {products.returnPolicy}</span><br />
                                    <span >minimumOrder Quantity-  {products.minimumOrderQuantity}</span><br />
                                    <span >created-  {products.meta.createdAt}</span><br />
                                    <span >updated-  {products.meta.updatedAt}</span><br />
                                    <span >barcode-  {products.meta.barcode}</span><br />
                                    <span ><img src={products.meta.qrCode} alt="" /></span><br />
                                </Col>
                            </>
                        )
                    }
                </Row>
            </Container>
        </>
    )
}

export default Single